export function rTime(date) {
    var json_date = new Date(date).toJSON();
    let str = new Date(+new Date(json_date) + 8 * 3600 * 1000).toISOString();
    return str.replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '').split(' ')[0];
}
